import { useGetAuthenticatedUser } from '../../../Flux/Selector/index.js'
import { useGetSystemMessages } from '../../../Flux/Selector/Application/GetSystemMessagesSelector.js'
import { useModal } from '../../Modal/UseModal.js'
import React, { useEffect } from 'react'
import { Environment } from '../../../environment.js'
import { useDispatch } from 'react-redux'
import { loadSystemMessages } from '../../../Flux/Slice/Application/ApplicationSlice.js'

export const localStorageKeyRedirectAfterRegister = 'redirect_after_register'

const VERSION_KEY = 'last-seen-spcfy-version'

export const PageLoadHooks = () => {
  const user = useGetAuthenticatedUser()
  const { openModal } = useModal()
  const dispatch = useDispatch()
  const systemMessages = useGetSystemMessages()

  /* show modal for fresh created users */
  useEffect(() => {
    if (user?.org?.isPending) {
      openModal('freshUser', {})
    }
  }, [user])

  /* changelog hook */
  useEffect(() => {
    if (user && Environment.SENTRY_ENVIRONMENT !== 'local') {
      const storedVersion = localStorage.getItem(VERSION_KEY)
      if (storedVersion !== Environment.SENTRY_RELEASE_VERSION) {
        localStorage.setItem(VERSION_KEY, Environment.SENTRY_RELEASE_VERSION)
        /* do not open changelog on changes, users won't read them */
        /* openModal('changelog', {}) */
      }
    }
  }, [user])

  /* system notifications: load + show if unseen */
  useEffect(() => {
    if (user) {
      dispatch(loadSystemMessages({ all: false }))
    }
  }, [user])

  useEffect(() => {
    if (user && systemMessages && systemMessages.length > 0) {
      const latest = [...systemMessages].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())[0]
      const key = 'last-seen-system-message-id'
      const seenId = localStorage.getItem(key)
      if (latest && latest.id && seenId !== latest.id) {
        localStorage.setItem(key, latest.id)
        openModal('systemNotifications', {})
      }
    }
  }, [systemMessages, user])

  return <></>
}
